import { useRouter } from 'next/router';

import { Box, Button, Icon, Paragraph } from '@zillow/constellation-10';
import { IconWarningOutline } from '@zillow/constellation-icons';

import { ERROR_MESSAGES } from '../../../constants/PaymentConstants';

type Props = {
  errorMessage: string;
  defaultErrorMessage?: string;
  isInMaintenanceMode?: boolean;
};

const PaymentError = ({
  errorMessage,
  defaultErrorMessage = ERROR_MESSAGES.DEFAULT,
  isInMaintenanceMode = false,
}: Props) => {
  const router = useRouter();

  return (
    <Box css={{ textAlign: 'center' }}>
      <Box
        css={{
          paddingInline: '600',
          paddingBlock: '800',
          backgroundColor: isInMaintenanceMode ? 'bg.accent.yellow.impact' : 'bg.express.empower.hero',
        }}
        data-testid={`PaymentError-header${isInMaintenanceMode ? '-maintenanceMode' : ''}`}
      >
        <Icon css={{ color: 'icon.onHero.neutral' }} size="xl" render={<IconWarningOutline />} />
      </Box>
      <Paragraph css={{ padding: '800' }} className="PaymentError-body">
        {errorMessage || defaultErrorMessage}
      </Paragraph>
      <Button fluid tone="brand" emphasis="outlined" css={{ paddingBottom: '400' }} onClick={() => router.reload()}>
        Reload page
      </Button>
    </Box>
  );
};

export default PaymentError;
